function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".reporta{fill:#5594ff;}"));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(-1739.637 -9705)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(1739.637 9715.73)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(0 0)"
}, /*#__PURE__*/React.createElement("path", {
  className: "reporta",
  d: "M1784.09,9773.926h-40.525a3.932,3.932,0,0,1-3.928-3.928v-47.412a3.933,3.933,0,0,1,3.928-3.929h40.525a3.933,3.933,0,0,1,3.928,3.929V9770A3.932,3.932,0,0,1,1784.09,9773.926Zm-39.739-4.714H1783.3v-45.841h-38.953Z",
  transform: "translate(-1739.637 -9718.657)"
})), /*#__PURE__*/React.createElement("path", {
  className: "reporta",
  d: "M1779.879,9736.1h-9.712a2.357,2.357,0,1,1,0-4.714h9.712a2.357,2.357,0,1,1,0,4.714Z",
  transform: "translate(-1745.674 -9721.384)"
}), /*#__PURE__*/React.createElement("path", {
  className: "reporta",
  d: "M1777.065,9751.3h-20.029a2.357,2.357,0,1,1,0-4.714h20.029a2.357,2.357,0,1,1,0,4.714Z",
  transform: "translate(-1742.86 -9724.642)"
}), /*#__PURE__*/React.createElement("path", {
  className: "reporta",
  d: "M1777.065,9763.2h-20.029a2.357,2.357,0,1,1,0-4.714h20.029a2.357,2.357,0,1,1,0,4.714Z",
  transform: "translate(-1742.86 -9727.192)"
}), /*#__PURE__*/React.createElement("path", {
  className: "reporta",
  d: "M1777.065,9775.107h-20.029a2.357,2.357,0,1,1,0-4.714h20.029a2.357,2.357,0,1,1,0,4.714Z",
  transform: "translate(-1742.86 -9729.743)"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(1750.372 9705)"
}, /*#__PURE__*/React.createElement("path", {
  className: "reporta",
  d: "M1797.775,9760.27h-9.194v-4.715h8.369v-45.841h-38.935v8.374H1753.3v-9.2a3.894,3.894,0,0,1,3.888-3.89h40.586a3.894,3.894,0,0,1,3.889,3.89v47.491A3.893,3.893,0,0,1,1797.775,9760.27Z",
  transform: "translate(-1753.3 -9705)"
})));

var SvgReport = function SvgReport(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 59.099,
    height: 65.999,
    viewBox: "0 0 59.099 65.999",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgReport, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/report.17828585.svg";
export { ForwardRef as ReactComponent };